/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Password_Errors_Password_Requires_DigitInputs */

const nl_auth_password_errors_password_requires_digit = /** @type {(inputs: Auth_Password_Errors_Password_Requires_DigitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Het wachtwoord moet minimaal één cijfer bevatten`)
};

/**

* @param {Auth_Password_Errors_Password_Requires_DigitInputs} inputs
* @param {{ locale?: "nl" }} options
* @returns {LocalizedString}
*/
const auth_password_errors_password_requires_digit = /** @type {((inputs?: Auth_Password_Errors_Password_Requires_DigitInputs, options?: { locale?: "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Password_Errors_Password_Requires_DigitInputs, { locale?: "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return nl_auth_password_errors_password_requires_digit(inputs)
});
export { auth_password_errors_password_requires_digit as "auth.password_errors.password_requires_digit" }